import { Button, Box, Typography, Stack } from '@mui/material';
import { useDeleteTeamMember, useGetTeamMembers } from 'apis/business/setting/team/hook';
import { GoPlus } from 'react-icons/go';
import Pagination, { usePagination } from 'components/Common/Pagination';
import TeamMemberCard from './components/TeamMemberCard';
import { useNavigate } from 'react-router-dom';
import { EmptyStateView } from '@/components/Common/EmptyStateView';
import TeamMemberCardsSkeleton from './components/TeamMemberCardSkeleton';

export default function TeamMembers() {
  const navigate = useNavigate();
  const { currentPage, perPage, setPage, setPerPage } = usePagination();
  const { data: teamMembers, isLoading } = useGetTeamMembers({ page: currentPage, per_page: perPage });
  const { mutate: deleteTeamMember } = useDeleteTeamMember();

  return (
    <>
      <Box display='flex' justifyContent='space-between' alignItems='flex-start' mb={3}>
        <Box>
          <Typography variant='h6' fontWeight={500}>
            Team
          </Typography>
          <Typography variant='body2' color='text.secondary' mt={0.5}>
            Manage human agents who can access platform take over or assist on live conversations.
          </Typography>
        </Box>

        <Button onClick={() => navigate('add')} variant='contained' startIcon={<GoPlus />}>
          Add Member
        </Button>
      </Box>

      {isLoading || teamMembers?.data?.length ? (
        <Stack spacing={2}>
          {isLoading ? (
            <TeamMemberCardsSkeleton />
          ) : (
            teamMembers?.data?.map((member, idx) => (
              <TeamMemberCard
                key={member.id}
                idx={idx}
                member={member}
                onEdit={() => navigate(String(member.id))}
                onDelete={() => deleteTeamMember(String(member.id))}
              />
            ))
          )}
        </Stack>
      ) : (
        <Box mt={10}>
          <EmptyStateView message='No Team Member Found' />
        </Box>
      )}

      <Pagination
        totalPages={teamMembers?.meta?.total_pages}
        totalCount={teamMembers?.meta?.total_count ?? 0}
        currentPage={currentPage}
        perPage={perPage}
        onChange={setPage}
        onPerPageChange={setPerPage}
      />
    </>
  );
}
